class SessionStorage {
  set(key, value) {
    // add or overwrite data in session storage.
    console.log('Setting session storage', key, value);
    sessionStorage.setItem(key, value);
  }

  setNotNull(key, value) {
    // add or overwrite data in session storage.
    console.log('Setting session storage', key, value);
    if (value !== null) {
      sessionStorage.setItem(key, value);
    }
  }

  setNotEmpty(key, value) {
    // add or overwrite data in session storage.
    console.log('Setting session storage', key, value);
    if (Array.isArray(value) && value.length > 0) {
      sessionStorage.setItem(key, value);
    }
  }

  has(key) {
    return sessionStorage.hasOwnProperty(key);
  }

  get(key, success, error) {
    // if we have data in session storage then retrieve it and call the callback function
    console.log('Getting session storage', key);
    // Delete the item from session storage.
    if (sessionStorage.hasOwnProperty(key)) {
      let data = sessionStorage.getItem(key);
      success(data);
    } else {
      error();
    }
  }

  remove(key) {
    sessionStorage.removeItem(key);
  }

  getRemove(key, success, error) {
    // if we have data in session storage then retrieve it and call the callback function
    console.log('Getting session storage', key);
    // Delete the item from session storage.
    if (sessionStorage.hasOwnProperty(key)) {
      let data = sessionStorage.getItem(key);
      sessionStorage.removeItem(key);
      success(data);
    } else {
      error();
    }
  }
}

export default new SessionStorage();
